// src/components/admin/KpiTile.tsx
interface Props {
  label: string;
  value: number | string;
  hint?: string;
}

const formatNumber = (v: number | string): string => {
  if (typeof v === 'string') return v;
  return new Intl.NumberFormat('it-IT').format(v);
};

export const KpiTile = ({ label, value, hint }: Props) => (
  <div className="rounded-lg border bg-card p-4 flex flex-col gap-1">
    <div className="text-sm text-muted-foreground">{label}</div>
    <div className="font-mono text-2xl font-semibold tabular-nums">{formatNumber(value)}</div>
    {hint && <div className="text-xs text-muted-foreground">{hint}</div>}
  </div>
);
